<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_main_contact_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >Find Contact</template
    >

    <template slot="body">
      <div class="contact-search">
        <InputField
          :id="'contact_search'"
          :value="searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'around'
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>

      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight
            }"
          >
            <th class="dt-table2--column">Name</th>
            <th class="dt-table2--column">Address</th>
            <th class="dt-table2--column">Mail</th>
            <th class="dt-table2--column">Telephone</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
          <tr
            class="dt-table2--row"
            v-for="contact in contacts"
            :key="contact.contact_id"
            @click="e => onRowClicked(contact)"
          >
            <td class="dt-table2--column">{{ contact["contact_name"] }}</td>
            <td class="dt-table2--column">{{ contact["address1"] }}</td>
            <td class="dt-table2--column">{{ contact["email1"] }}</td>
            <td class="dt-table2--column">{{ contact["phone1"] }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancel">Cancel</button>
      <button
        v-if="config && config.isCompany"
        class="dt-button v1 with-ico s6"
        @click="onAddCompanyClicked"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">{{ $t("add") }} {{ $t("short_name") }}</div>
      </button>
      <button
        v-if="config && config.isIndividual"
        class="dt-button v1 with-ico s6"
        @click="onAddPersonClicked"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">{{ $t("add") }} {{ $t("Person") }}</div>
      </button>

      <template v-if="addPersonModalContainer">
        <v-dialog persistent v-model="addPersonModal" width="390">
          <AddPerson
            :groups="groups"
            @new_contact="onNewContact"
            @cancelled="onAddPersonCancelled"
          />
        </v-dialog>
      </template>
      <template v-if="addCompanyModalContainer">
        <v-dialog persistent v-model="addCompanyModal" width="390">
          <AddCompany
            :groups="groups"
            :countries="countries"
            @new_contact="onNewContact"
            @cancelled="onAddCompanyCancelled"
          />
        </v-dialog>
      </template>
    </template>
  </Modal>
</template>

<script>
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { Subject } from "rxjs";
import InputField from "../../../../plugins/text-field/input-field";
import AddPerson from "../../../../dt-plugins/add-contact-relation/add-person";
import AddCompany from "../../../../dt-plugins/add-contact-relation/add-company";
import { subscribeSubject } from "../../../../utility";
import Modal from "../../../../dt-plugins/modal/modal";
import {
  createModalMixin,
  closeModal2Route,
  openModal2Route
} from "../../../../dt-plugins/modal/modal.mixin";
import { getContactRelationConfiguration } from "../../../../dt-plugins/add-contact-relation/config-map";
import { ContactService } from "../../../../dt-plugins/add-contact-relation/contact.service";
import { AccountsService } from "../../services/accounts.service";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
export default {
  components: {
    InputField,
    AddPerson,
    AddCompany,
    Modal
  },
  props: ["selectedAccountDetails"],
  mixins: [
    createModalMixin("addPerson", [], {
      modalQueryKey: "modal2"
    }),
    createModalMixin("addCompany", [], {
      modalQueryKey: "modal2"
    })
  ],
  watch: {
    searchString: {
      immediate: true,
      handler: function(to, from) {
        console.log(`searchString Change to ${to} from ${from}`);
      }
    }
  },
  data: function() {
    return {
      contacts: [],
      searchString: "",
      contactSubject$: new Subject(),

      contactHeaders: ["Name", "Address", "Mail", "Telephone"],
      searchSize: "single",

      groups: [],
      externalTable: "account",
      addPersonModalContainer: false,
      addPersonModal: false,

      addCompanyModal: false,
      addCompanyModalContainer: false
    };
  },
  mounted: function() {
    ContactService.findContacts({
      contactSearchType: this.config.contactSearchType
    }).then(contacts => {
      this.contacts = contacts.data.map(createContact);
    });

    ContactService.findContactGroups().then(res => {
      this.groups = res.data.groups.map(e => ({
        text: e.group_name,
        value: e.group_id
      }));
    });

    // Artist Subscription
    subscribeSubject(this, this.contactSubject$, searchString => {
      console.warn(searchString);
      ContactService.findContacts({
        searchString,
        contactSearchType: this.config.contactSearchType
      }).then(contacts => {
        this.contacts = contacts.data.map(createContact);
      });
    });
    // this.$subscribeTo(
    //   this.contactSubject$.asObservable().pipe(
    //     debounceTime(300),
    //     distinctUntilChanged()
    //   ),

    // );
  },
  computed: {
    ...mapGetterObject(storeNS, accountsRoyaltyGetters),
    hRowMarginRight: function() {
      if (this.contacts.length > 380 / 28) {
        return "28px";
      }
    },
    config: function() {
      return this.externalTable
        ? getContactRelationConfiguration(this.externalTable)
        : undefined;
    }
  },
  methods: {
    addChecklist: function(e) {
      // this.$emit('ADD_NEW', this.checklist_title);
      this.checklist_title = "";
      // this.$emit('CANCEL', false);
    },
    onCancel: function(e) {
      // this.$emit('CANCEL', false);
    },
    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value);
      this.contactSubject$.next(this.searchString);
    },
    searchContact: function() {
      ContactService.searchContacts({
        searchString: this.searchString
      }).then(contacts => {
        this.contacts = contacts.map(createContact);
      });
    },
    onRowClicked: async function(contact) {
      const insertedContactRelation = await AccountsService.addRoyaltyAccountMainContact(
        {
          royalty_account_id: this.selectedAccountDetails?.account
            ?.royalty_account_id,
          contact_id: contact.contact_id
        }
      );

      this.contactRelationAdded(insertedContactRelation.data.item_contact);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddPersonClicked: function(e) {
      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     ...this.$route.query,
      //     modal2: 'add_person'
      //   }
      // });
      openModal2Route(this, "add_person");

      // this.addPersonModalContainer = true;
      // waitForAnimation(() => {
      //   this.addPersonModal = true;
      // });
    },
    onAddPersonCancelled: function() {
      // this.$router.push({
      //   query: {
      //     ...this.$route.query,
      //     modal2: undefined
      //   }
      // });
      closeModal2Route(this);
      // this.addPersonModal = false;

      // waitForAnimation(() => {
      //   this.addPersonModalContainer = false;
      // });
    },
    onAddCompanyClicked: function() {
      openModal2Route(this, "add_company");
      // this.addCompanyModalContainer = true;
      // waitForAnimation(() => {
      //   this.addCompanyModal = true;
      // });
    },
    onAddCompanyCancelled: function() {
      closeModal2Route(this);
      // this.addCompanyModal = false;

      // waitForAnimation(() => {
      //   this.addCompanyModalContainer = false;
      // });
    },
    onNewContact: async function({ type, contact }) {
      console.log({ type, contact });
      switch (type) {
        case "person": {
          this.onAddPersonCancelled();
          const insertedPerson = await ContactService.insertPerson(contact);
          console.log(insertedPerson);
          const insertedContactRelation = await ContactService.insertContactRelation(
            {
              contactId: this.externalId,
              externalId: insertedPerson.data.contact_id,
              externalTable: this.externalTable,
              templateType: this.externalTable,

              contactSearchType: this.config.contactSearchType
            }
          );
          console.log(insertedContactRelation);

          this.contactRelationAdded(insertedContactRelation.data);
          break;
        }
        case "company": {
          this.onAddCompanyCancelled();

          const insertedCompany = await ContactService.insertCompany(contact);
          console.log(insertedCompany);
          const insertedContactRelation = await ContactService.insertContactRelation(
            {
              contactId: this.externalId,
              externalId: insertedCompany.data.contact_id,
              externalTable: this.externalTable,
              templateType: this.externalTable,

              contactSearchType: this.config.contactSearchType
            }
          );
          console.log(insertedContactRelation);

          this.contactRelationAdded(insertedContactRelation.data);

          break;
        }
      }
    },
    contactRelationAdded: function(payload) {
      this.$emit("added", {
        ...payload
      });
    }
  }
};

const createContact = ({
  contact_id,
  contact_name,
  city,
  address1,
  email1,
  phone1
}) => {
  if (!contact_id) {
    throw Error(`Can't create Contact without Contact ID`);
  }

  contact_name =
    contact_name && contact_name.length > 0 ? contact_name : "No Name";

  return {
    contact_id,
    contact_name,
    city,
    address1,
    email1,
    phone1
  };
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
</style>
